import React from "react";
import {useParams} from "react-router-dom";
import {ThemeProvider} from "@chakra-ui/core";

import getTheme from "../app/theme";
import {useToast} from "../hooks/toast";

import LoadingScreen from "./screens/Loading";
import FailedScreen from "./screens/Failed";
import {Tenant, Context, State, Actions, Status} from "./types";
import api from "./api";

const ProductTenant = React.createContext({} as Context);

const TenantProvider: React.FC = ({children}) => {
  const {tenant: id} = useParams();
  const toast = useToast();
  const [tenant, setTenant] = React.useState<Tenant | null>(null);
  const [status, setStatus] = React.useState<Status>("pending");

  function update(tenant: Tenant) {
    return api
      .update(tenant)
      .then(() => {
        setTenant(tenant);

        toast({
          title: "Tienda actualizada",
          description: "Tu tienda fue actualizada correctamente",
          status: "success",
        });
      })
      .catch(() => {
        toast({
          title: "Error",
          description: "Hubo un error actualizando tu tienda, es esta tu tienda?",
          status: "error",
        });
      });
  }

  React.useEffect(() => {
    if (!id) {
      return setStatus("rejected");
    }

    api
      .fetch(id)
      .then((tenant) => {
        setTenant(tenant);

        setStatus("resolved");
      })
      .catch(() => {
        setTenant(null);

        setStatus("rejected");
      });

    return () => setStatus("pending");
  }, [id]);

  if (status === "pending") return <LoadingScreen />;
  if (!tenant) return <FailedScreen />;

  const state: State = {tenant};
  const actions: Actions = {update};

  return (
    <ThemeProvider theme={getTheme(tenant.color)}>
      <ProductTenant.Provider value={{state, actions}}>{children}</ProductTenant.Provider>
    </ThemeProvider>
  );
};

export {TenantProvider as Provider, ProductTenant as default};
